import { TXGUISection } from "../interfaces/gui/fields.interfaces";
import { TComponentName } from "../types/common/components.types";
import { X_ARTICLE_GUI_FIELDS } from "./commons/XArticle.settings";
import { X_FOOTER_GUI_FIELDS } from "./commons/XFooter.settings";
import { X_HEADER_GUI_FIELDS } from "./commons/XHeader.settings";
import { X_CAROUSEL_GUI_FIELDS } from "./containers/XCarousel.settings";
import { X_CATEGORY_FILTER_GUI_FIELDS } from "./containers/XCategoryFilter.settings";
import { X_GRID_GUI_FIELDS } from "./containers/XGrid.settings";
import { X_PRODUCT_DETAILS_GUI_FIELDS } from "./containers/XProductDetails";
import { X_STACK_GUI_FIELDS } from "./containers/XStack.settings";
import { X_BREADCRUMB_GUI_FIELDS } from "./elements/XBreadcrumb.settings";
import { X_BUTTON_GUI_FIELDS } from "./elements/XButton.settings";
import { X_FORM_GUI_FIELDS } from "./elements/XForm.settings";
import { X_ICON_GUI_FIELDS } from "./elements/XIcon.settings";
import { X_IMAGE_GUI_FIELDS } from "./elements/XImage.settings";
import { X_MAP_GUI_FIELDS } from "./elements/XMap.settings";
import { X_RATING_GUI_FIELDS } from "./elements/XRating.settings";
import { X_TEXT_GUI_FIELDS } from "./elements/XText.settings";

export type TSettingsGUI = {
  [name in TComponentName]?: TXGUISection;
};

export const SETTINGS_GUI: TSettingsGUI = {
  //COMMONS
  XFooter: X_FOOTER_GUI_FIELDS,
  XHeader: X_HEADER_GUI_FIELDS,
  XArticle: X_ARTICLE_GUI_FIELDS,

  // CONTAINERS
  XStack: X_STACK_GUI_FIELDS,
  XGrid: X_GRID_GUI_FIELDS,
  XCarousel: X_CAROUSEL_GUI_FIELDS,
  XCategoryFilter: X_CATEGORY_FILTER_GUI_FIELDS,
  XProductDetails: X_PRODUCT_DETAILS_GUI_FIELDS,

  // ELEMENTS
  XBreadcrumb: X_BREADCRUMB_GUI_FIELDS,
  XButton: X_BUTTON_GUI_FIELDS,
  XForm: X_FORM_GUI_FIELDS,
  XIcon: X_ICON_GUI_FIELDS,
  XImage: X_IMAGE_GUI_FIELDS,
  XMap: X_MAP_GUI_FIELDS,
  XRating: X_RATING_GUI_FIELDS,
  XText: X_TEXT_GUI_FIELDS,
};
